// extracted by mini-css-extract-plugin
module.exports = {"changeFolderSelector":"changeFolderSelector__GFh0V"};